<template>
    <div>
        <div class="modal fade" id="addNote" tabindex="-1" aria-labelledby="addNoteLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addNoteLabel">Add Note</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="part_select" class="form-label">Select the part</label>
                            <select class="form-select" id="part_select" v-model="localPart">
                                <option :value="part">{{part}}</option>
                                <option v-for="part in parts" :key="part" :value="part" style="color: #DA1D62 !important;">{{ part }}</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="noteDescription" class="form-label">Description</label>
                            <textarea v-model="note" id="noteDescription" class="form-control" rows="5" placeholder="Enter your note..." :disabled="loading"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="loading">Close</button>
                        <button type="button" class="btn btn-primary" @click="saveNote" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ loading ? 'Saving...' : 'Save' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import NoteService from '@/services/note.service';

export default {
    name: 'ModalMoreDetailsQuote',
    props: {
        part: {
            type: String,
            default: '',
        },
        parts: {
            type: Array,
            default: () => [],
        }
    },
    mounted() {
    },
    data() {
        return {
            note: '',
            localPart: this.part,
            loading: false
        };
    },
    watch: {
        part: {
            immediate: true,
            handler(newPart) {
                this.localPart = newPart;
            }
        }
    },
    methods: {
        async resetNote() {
            this.note = '';
            this.localPart = this.part;
        },
        async saveNote() {
            if (!this.note.trim()) {
                alert('Please enter a note');
                return;
            }

            this.loading = true;
            try {
                const response = await NoteService.createUserNote({ note: this.note, part: this.localPart });
                if (response) {
                    this.note = '';
                    this.closeModal();
                } else {
                    alert('Failed to save note');
                }
            } catch (error) {
                console.error('Error saving note:', error);
                alert('An error occurred while saving the note');
            } finally {
                this.loading = false;
            }
        },
        closeModal() {
            const modalElement = document.getElementById('addNote');
            if (modalElement) {
                const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
                modal.hide();
            }
            this.$emit('closeModalAddNote');
        }
    }
}
</script>
